import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  FETCH_ALL_CAMPAIGN,
  ADD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_CONFIG,
  DELETE_CAMPAIGN,
} from '../actions/campaign/action_types';
import actions from '../actions/campaign';
import rf from '../../requests/RequestFactory';
import utils from '../../common/utils';
// saga effect

function* fetchAllCampaign(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('CampaignRequest').fetchAllCampaign(params), action.params);
    yield put(actions.onFetchAllCampaignActionSucceed(data, totalCount));
    if (isFunction(action.callback)) {
      yield action.callback(totalCount);
    }
  } catch (err) {
    yield put(actions.onFetchAllCampaignActionFailed(err));
  }
}

function* onAddCampaign(action) {
  try {
    yield call((params) => rf.getRequest('CampaignRequest').addCampaign(params), action.params);
    yield action.callback1();
    yield action.callback2();
    utils.showNotification('Thông báo', 'Thêm chiến dịch thành công', 'success');
  } catch (err) {
    yield action.callback2();
    yield put(actions.onAddCampaignActionFailed(err));
    console.log('=== ===');
    if (isFunction(action.onFailed)) {
      yield action.onFailed();
    }
  }
}

function* onUpdateCampaign(action) {
  try {
    yield call((params) => rf.getRequest('CampaignRequest').updateCampaign(params), action.params);
    // yield put(actions.onFetchAllCampaignAction(action.params.filter));
    yield action.callback1();
    yield action.callback2();
    utils.showNotification('Thông báo', 'Cập nhật chiến dịch thành công', 'success');
  } catch (err) {
    yield action.callback2();
    yield put(actions.onUpdateCampaignActionFailed(err));
  }
}

function* onUpdateCampaignConfig(action) {
  try {
    yield call((params) => rf.getRequest('CampaignRequest').updateCampaignConfig(params), action.data);
    utils.showNotification('Thông báo', 'Cập nhật cài đặt thành công', 'success');
  } catch (err) {
    yield put(actions.onUpdateCampaignActionFailed(err));
  }
}

function* onDeleteCampaign(action) {
  try {
    yield call((params) => rf.getRequest('CampaignRequest').deleteCampaign(params), action.params);
    // yield put(actions.onFetchAllCampaignAction(action.params.))filter;
    if (isFunction(action.callback1)) {
      yield action.callback1();
    }

    utils.showNotification('Thông báo', 'Xóa chiến dịch thành công', 'success');
  } catch (err) {
    console.log(err, ': err src/redux/sagas/campaign_saga.js:76');
  }
}

function* watchCampaign() {
  yield takeLatest(FETCH_ALL_CAMPAIGN, fetchAllCampaign);
  yield takeLatest(ADD_CAMPAIGN, onAddCampaign);
  yield takeLatest(UPDATE_CAMPAIGN, onUpdateCampaign);
  yield takeLatest(UPDATE_CAMPAIGN_CONFIG, onUpdateCampaignConfig);
  yield takeLatest(DELETE_CAMPAIGN, onDeleteCampaign);
}

export default function* rootSaga() {
  yield all([fork(watchCampaign)]);
}
